import { render } from "./ItemSponsor.vue?vue&type=template&id=1148f891&scoped=true"
import script from "./ItemSponsor.vue?vue&type=script&lang=js"
export * from "./ItemSponsor.vue?vue&type=script&lang=js"

import "./ItemSponsor.vue?vue&type=style&index=0&id=1148f891&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1148f891"

export default script